import { projectRequest } from 'store/utils/request';

export const addRuleRequest = async (groupId, data) => {
  try {
    return await projectRequest.post(`/rule_groups/${groupId}/rules/`, data);
  } catch (error) {
    throw error;
  }
};

export const getRuleRequest = async (groupId, id, requestId) => {
  try {
    return await projectRequest.get(`/rule_groups/${groupId}/rules/${id}/`, {
      requestId,
    });
  } catch (error) {
    throw error;
  }
};

export const updateRuleRequest = async (groupId, itemId, data) => {
  try {
    return await projectRequest.put(
      `/rule_groups/${groupId}/rules/${itemId}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const partialUpdateRuleRequest = async (groupId, itemId, data) => {
  try {
    return await projectRequest.patch(
      `/rule_groups/${groupId}/rules/${itemId}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteRuleRequest = async (groupId, id) => {
  try {
    return await projectRequest.delete(`/rule_groups/${groupId}/rules/${id}/`);
  } catch (error) {
    throw error;
  }
};
